import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[clickable]'
})
export class ClickableDirective {
  @HostBinding('class.clickable-link') class = true;
}
